import React, { useState } from 'react';
import { toast } from 'react-toastify';

// redux
import { connect } from 'react-redux';
import { DeleteMerchantUser, UpdateMerchantSupportUser } from 'store/actions/merchantActions';
import { useTranslation } from 'react-i18next';
import AppCenteredModal from 'components/new_components/AppCenteredModal';
import { Box } from '@mui/material';
import { Loader2 } from 'lucide-react';

const UserDeleteModal = (props) => {
    const { open, handleClose, payload, DeleteMerchantUser, UpdateMerchantSupportUser } = props;

    const [deleting, setDeleting] = useState(false);

    //translation
    const { t } = useTranslation('user');

    const handleDelete = async () => {
        setDeleting(true);
        const res =
            payload.role === 'support'
                ? await UpdateMerchantSupportUser({
                      support_user: null,
                      support_routes: '',
                  })
                : await DeleteMerchantUser(payload.user_detail.id);
        setDeleting(false);
        if (res?.success) {
            toast.success('Successfully deleted a user.');
            handleClose();
        } else {
            toast.error(res?.message);
        }
    };

    return (
        // <AppDeleteModal
        //     open={open}
        //     handleClose={handleClose}
        //     title={t('deleteModal.title')}
        //     subtitle={t('deleteModal.subtitle')}
        //     deleting={deleting}
        //     onDelete={handleDelete}
        // />
        <AppCenteredModal
            noBorder
            open={open}
            handleClose={handleClose}
            // title={<span className="text-[#202d66]">{isAddModal ? t('createUser') : t('updateUser')}</span>}
            width={470}
            dialogActionsStyle={{
                bgcolor: '#F8FAFC',
            }}
            actions={
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        py: 1.5,
                        gap: 1,
                        bgcolor: '##F8FAFC',
                    }}
                >
                    <button
                        size="small"
                        onClick={handleClose}
                        className="!text-capitalize font-medium border border-[#E2E8F0] text-[#334155] bg-white rounded-sm text-sm px-[15px] py-[8px]"
                    >
                        Cancel
                    </button>
                    <button
                        disabled={deleting}
                        size="small"
                        onClick={handleDelete}
                        className="!text-capitalize font-medium text-[#fff] bg-[#FF5449] rounded-sm text-sm px-[15px] py-[8px] w-[max-content] flex items-center justify-center disabled:opacity-70"
                    >
                        {deleting && <Loader2 className="mr-1 h-6 w-6 animate-spin" />}
                        Yes, delete
                    </button>
                </Box>
            }
        >
            <h3 className="font-bold text-[#475569] text-xl text-center mb-2.5">{t('deleteModal.title')}?</h3>
            <p className="text-[#64748B] text-center text-sm mb-4">{t('deleteModal.subtitle')}</p>
        </AppCenteredModal>
    );
};
const mapStateToProps = (state) => {
    return { ...state };
};
export default connect(mapStateToProps, {
    UpdateMerchantSupportUser,
    DeleteMerchantUser,
})(UserDeleteModal);
